import React, { useState, useEffect } from 'react';
import {
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
    Button,
    CircularProgress,
} from '@mui/material';
import PropTypes from 'prop-types';

const MyCredPaymentGateway = ({
    title,
    description,
    handleGatewayChange,
    submitBooking,
    ordertotal,
    balancelabel,
    balance,
    showtotal,
    state,
    setState,
}) => {
    const [isChecked, setIsChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [reference] = useState("bookify_payment_pts"); // Fixed reference value
    const siteUrl = `${window.location.origin}/wp-json/mycred-bookify/v1/deduct-points`;

    useEffect(() => {
        setIsChecked(state.gateway === 'mycred_gateway');
    }, [state.gateway]);

    console.log(state);

    async function deductPoints(points) {
        if (!reference || !state.customerId) {
            alert("Missing required booking details. Please check your booking.");
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(siteUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': window.wpApiSettings?.nonce,
                },
                body: JSON.stringify({ points, reference, post_id: state.customerId }),
            });

            if (!response.ok) throw new Error(`Error: ${response.statusText}`);

            const data = await response.json();
            if (data.success) {
                submitBooking(); // Proceed with booking if points deduction is successful
            } else {
                console.error("Failed to deduct points:", data.message);
                alert("Error: " + data.message);
            }
        } catch (error) {
            console.error("Error during points deduction:", error.message);
            alert("You do not have enough points to complete this payment.");
        } finally {
            setLoading(false);
        }
    }

   


    return (
        <RadioGroup
            aria-labelledby="bookify-payment-methods"
            value={state.gateway}
            onChange={handleGatewayChange}
        >
            <FormControlLabel
                value="mycred_gateway"
                control={<Radio size="small" />}
                label={title}
            />

            {isChecked && (
                <>
                    <Typography variant="body1" sx={{ mt: 2 }}>
                        {description}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        {`${ordertotal}: ${state.servicePrice}`}
                    </Typography>
                    {showtotal === 'checkout' && (
                        <Typography variant="body2" sx={{ mt: 1 }}>
                            {`${balancelabel}: ${balance}`}
                        </Typography>
                    )}
                    <Button
                        variant="contained"
                        onClick={() => deductPoints(state.servicePrice)}
                        sx={{
                            backgroundColor: '#036666',
                            mt: 2,
                            '&:hover': { backgroundColor: '#024c4c' },
                        }}
                        disabled={loading}
                    >
                        {loading ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            'Submit'
                        )}
                    </Button>
                </>
            )}
        </RadioGroup>
    );
};

MyCredPaymentGateway.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    handleGatewayChange: PropTypes.func.isRequired,
    submitBooking: PropTypes.func.isRequired,
    ordertotal: PropTypes.string.isRequired,
    balancelabel: PropTypes.string.isRequired,
    balance: PropTypes.number.isRequired,
    showtotal: PropTypes.string.isRequired,
    state: PropTypes.shape({
        gateway: PropTypes.string.isRequired,
        servicePrice: PropTypes.number.isRequired,
        customerId: PropTypes.number.isRequired, 
    }).isRequired,
    setState: PropTypes.func.isRequired,
};



export default MyCredPaymentGateway;
